'use client';

import { useState, useEffect } from 'react';
import MetricsSection from './metrics-section';
import ChartsSection from './charts-section';
import VesselDataTable from './vessel-data-table';
import NotificationPanel from './notification-panel';
import ChartsPieSection from './charts-pie-section';
import ActiveVoyagesSection from './active-voyages-section';
import { DashboardData } from '@/types/api';

interface DashboardProps {
  data: DashboardData;
}

export default function DashboardMetrics({ data }: DashboardProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  if (!isLoaded || !data) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 dark:border-gray-400"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Row 1: KPI Metrics (4 compact summary cards) */}
      <MetricsSection data={data} />

      {/* Row 2: Active Voyagers & Selected ETA (Left) + Vessel Condition Donut (Right) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
        <ActiveVoyagesSection data={data} />
        <ChartsPieSection data={data} />
      </div>

      {/* Row 3: Expired Devices By Month (Left) + Latest Expired Vessels (Right) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
        <ChartsSection data={data} />
        <NotificationPanel data={data} />
      </div>

      {/* Row 4: Latest Update Tracking Ping Table (Full width) */}
      <div className="w-full">
        <VesselDataTable data={data} />
      </div>
    </div>
  );
}
